import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import {
  assertStatus,
  extractTotalCountHeader,
} from "@mittwald/api-client-NEXT";
import type { ContractBehaviors } from "./types.js";

export const apiContractBehaviors = (
  client: MittwaldAPIV2Client,
): ContractBehaviors => ({
  find: async (contractId) => {
    const response = await client.contract.getDetailOfContract({ contractId });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (customerId, query) => {
    const response = await client.contract.listContracts({
      queryParameters: query,
      customerId,
    });
    assertStatus(response, 200);
    return {
      items: response.data,
      totalCount: extractTotalCountHeader(response),
    };
  },

  terminate: async (contractId, data) => {
    const response = await client.contract.terminateContract({
      contractId,
      data,
    });

    assertStatus(response, 201);
  },

  cancelTermination: async (contractId) => {
    const response = await client.contract.cancelContractTermination({
      contractId,
    });

    assertStatus(response, 200);
  },

  findByProject: async (projectId) => {
    const response = await client.contract.getDetailOfContractByProject({
      projectId,
    });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  findByServer: async (serverId) => {
    const response = await client.contract.getDetailOfContractByServer({
      serverId,
    });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  cancelTariffChange: async (contractId, contractItemId) => {
    const response = await client.contract.cancelContractTariffChange({
      contractId,
      contractItemId,
    });

    assertStatus(response, 200);
  },
});
